<template>
    <div
        v-if="isNoEmrAfterOperated && (this.surgeryInfo.enum_surgery_status == 40 || this.surgeryInfo.enum_surgery_status == 60)"
        style="margin: 0px 0; line-height: 600px; font-size: 30px; opacity: 0.5; text-align: center"
    >
        手术已结束或复苏结束,不允许查看!
    </div>
    <div v-else>
        <el-container v-wechat-title="title" :style="{ height: this.screenHeight - 115 + 'px', position: 'relative' }">
            <el-aside v-if="displayMode != 2" width="300px">
                <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                    <div style="padding: 5px 10px">
                        <el-input v-model="queryInput" placeholder="快速查找"></el-input>
                    </div>
                    <el-menu v-if="examList.length > 0" unique-opened :default-active="firstExamNo" @select="handleSelect">
                        <el-submenu v-for="date in examGroupDates" :index="date" :key="date" align="left">
                            <template slot="title">
                                <i class="el-icon-time"></i>
                                <span>{{ date }}</span>
                            </template>
                            <el-menu-item v-for="item in examGroup[date]" :index="item.exam_no" :key="item.exam_no">
                                <span>{{ $moment(item.report_dt).format('HH:mm') }}</span>
                                <span>{{ item.exam_name }}</span>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
                </el-scrollbar>
            </el-aside>
            <el-main class="width-p100" style="padding: 10px; margin-left: 10px; height: 100%; background: white" v-loading="loading">
                <div v-if="displayMode != 0 && currentExamRefUrl" style="text-align: left">
                    <el-link v-if="isCustomProtocol" :href="currentExamRefUrl" target="_blank" type="primary"><i class="el-icon-link"></i>报告详情</el-link>
                    <iframe v-else frameborder="0" scrolling="auto" :src="currentExamRefUrl" :height="this.screenHeight - 140" width="100%"></iframe>
                </div>
                <div v-else-if="currentExam">
                    <el-row>
                        <el-col :span="12">
                            <div class="report-no">检查单号#{{ currentExam.exam_no }}</div>
                            <div class="report-title">{{ currentExam.exam_name }}</div>
                        </el-col>
                        <el-col :span="12">
                            <div class="report-request-dt">申请时间：{{ $moment(currentExam.request_dt).format('YYYY/MM/DD HH:mm') }}</div>
                            <div class="report-report-dt">报告时间：{{ $moment(currentExam.report_dt).format('YYYY/MM/DD HH:mm') }}</div>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <div class="report-content-container">
                        <table>
                            <tr v-if="currentExam.exam_method">
                                <td width="100">检查方法：</td>
                                <td>{{ currentExam.exam_method }}</td>
                            </tr>
                            <tr v-if="currentExam.description">
                                <td width="100">检查所见：</td>
                                <td>{{ currentExam.description }}</td>
                            </tr>
                            <tr v-if="currentExam.impression">
                                <td width="100">检查印象：</td>
                                <td>{{ currentExam.impression }}</td>
                            </tr>
                            <tr v-if="currentExam.recommendation">
                                <td width="100">建议：</td>
                                <td>{{ currentExam.recommendation }}</td>
                            </tr>
                            <tr v-if="currentExam.ref_url">
                                <td colspan="2"><el-link type="primary" target="_blank" :href="currentExam.ref_url">报告影像</el-link></td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5">
                    <span class="el-icon-document"></span>
                </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `Exam`,
    props: {},
    data() {
        return {
            title: `检查`,
            queryInput: ``,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            exams: [],
            displayMode: this.$root.ExamDisplayMode,
            refUrl: this.$root.ExamRefUrl,
            loading: false,
            currentExam: null,
            surgeryInfo: {},
            visitInfo: {},
            isNoEmrAfterOperated: false
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        examList() {
            let queryInput = this.queryInput
            let examList = _.filter(this.exams, value => {
                return _.includes(value.exam_name.toUpperCase(), queryInput.toUpperCase())
            })
            return _.orderBy(examList, `report_dt`, `desc`)
        },
        examGroup() {
            return _.groupBy(this.examList, value => {
                return this.$moment(value.report_dt).format(`YYYY/MM/DD`)
            })
        },
        examGroupDates() {
            let dates = _.keys(this.examGroup)
            dates = _.orderBy(dates, null, `desc`)
            return dates
        },
        firstExam() {
            return this.examGroupDates.length > 0 ? this.examGroup[this.examGroupDates[0]][0] : null
        },
        firstExamNo() {
            return this.firstExam && this.firstExam.exam_no
        },
        currentExamRefUrl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentExam) {
                // refUrl = refUrl.replace(`@examNo`, this.currentExam.exam_no)
                refUrl = refUrl.replace(`@examNo` + jmType, jmType == `` ? this.currentExam.exam_no : window.btoa(unescape(encodeURIComponent(this.currentExam.exam_no))))
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    // refUrl = refUrl.replace(`@${key}`, value)
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.visitInfo) {
                _.each(this.visitInfo, (value, key) => {
                    // refUrl = refUrl.replace(`@${key}`, value)
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.surgeryInfo) {
                _.each(this.surgeryInfo, (value, key) => {
                    // refUrl = refUrl.replace(`@${key}`, value)
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            return refUrl
        },
        isCustomProtocol() {
            return !_.startsWith(this.currentExamRefUrl, `http`)
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.isNoEmrAfterOperated = this.$root.IsNoEmrAfterOperated == `1`
    },
    mounted() {
        this.loadSurgery()
        this.loadExam()
    },
    methods: {
        isjson(jsonstr) {
            if (typeof jsonstr == `string`) {
                try {
                    var obj = JSON.parse(jsonstr)
                    if (typeof obj == `object` && obj) {
                        return true
                    } else {
                        return false
                    }
                } catch (e) {
                    return false
                }
            }
            return false
        },
        loadSurgery() {
            if (!this.surgeryId) {
                this.surgeryInfo = {}
                this.visitInfo = {}
                return
            }
            var that = this
            this.myaxios
                .get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                .then(data => {
                    let extrDatas = _.reduce(data.extra_datas, function(result, value, index) {
                        let flag = that.isjson(value.DataValue)
                        if (value.DataValue != `` && flag == true) {
                            result[value.DataKey] = value.DataExtraValue
                        } else {
                            result[value.DataKey] = value.DataValue
                        }
                        return result
                    }, {})
                    this.surgeryInfo = Object.assign(data, extrDatas)
                    this.visitInfo = data.visit_info
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadExam() {
            if (!this.surgeryId) {
                this.exams = []
                return
            }
            this.myaxios
                .get(`/api/Nursing/Exam/Get?surgeryId=${this.surgeryId}`)
                .then(data => {
                    this.exams = data
                })
                .catch(e => {
                    console.log(e)
                })
        },
        handleSelect(index) {
            this.currentExam = _.find(this.examList, {
                exam_no: index
            })
        }
    },
    watch: {
        firstExam(value) {
            this.currentExam = value
        },
        $route: function(newUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadSurgery()
            this.loadExam()
        }
    }
}
</script>
<style scoped lang="less">
.report-content-container {
    margin-top: 15px;
    text-align: left;
    td {
        vertical-align: top;
        padding: 10px 0;
        line-height: 32px;
    }
    .el-link {
        font-size: 16px;
    }
}
.report-no {
    padding-top: 5px;
    text-align: left;
    font-size: 14px;
    color: #909399;
}
.report-title {
    text-align: left;
    font-size: 24px;
    color: #303133;
    font-weight: bold;
    padding-top: 5px;
}
.report-request-dt,
.report-report-dt {
    padding-top: 10px;
    text-align: right;
    font-size: 14px;
    color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Exam/Index.vue